import { Component } from '@angular/core';

@Component({
  selector: 'app-miscellaneous-icon',
  templateUrl: './miscellaneous-icon.component.svg',
  styleUrls: ['./miscellaneous-icon.component.scss']
})
export class MiscellaneousIconComponent
{

  constructor() { }

}
